var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isEmbed)?_c('div',[_c('i',{staticClass:"material-icons mic-icon",class:_vm.isRecording ? 'mic-recording' : '',on:{"click":function($event){return _vm.startSpeechToText()}}},[_vm._v("mic")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e90138ac","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/speech/SpeechInput.vue
// module id = 845
// module chunks = 38